import type { Plugin } from '@nuxt/types'
import { defineNuxtPlugin } from 'nuxt/app'
import InitialEventSalesDataWorker from './ar-web-worker/initial-event-sales-data.worker.ts?worker'
import OverlaySalesQuantityWorker from './ar-web-worker/overlay-sales-quantity.worker.ts?worker'
import OverlayTimescaleDataWorker from './ar-web-worker/overlay-timescale-data.worker.ts?worker'

const workerPlugin = {
  createInitialEventSalesDataWorker() {
    // @ts-ignore
    return new InitialEventSalesDataWorker()
  },
  createOverlaySalesQuantityWorker() {
    // @ts-ignore
    return new OverlaySalesQuantityWorker()
  },
  createOverlayTimescaleDataWorker() {
    // @ts-ignore
    return new OverlayTimescaleDataWorker()
  },
}

// declare module 'vue/types/vue' {
//   interface Vue {
//     $arWorker: typeof workerPlugin
//   }
// }

// declare module '@nuxt/types' {
//   interface NuxtAppOptions {
//     $arWorker: typeof workerPlugin
//   }
// }

// declare module 'vuex/types/index' {
//   interface Store<S> {
//     $arWorker: typeof workerPlugin
//   }
// }

export default defineNuxtPlugin((app) => {
  app.provide('arWorker', workerPlugin)
})
// {
//   name: 'ar-filters',
//   parallel: true,
//   async setup (app) {
//     app.vueApp.provide('arWorker', workerPlugin)
//   }
// })
